export default __webpack_public_path__ + "static/media/10.59a20061.webp";